module.exports = __webpack_public_path__ + "static/media/icon-minimize.b121f64c.svg";